/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import Calculate from 'components/payments/Calculator';
import Formmoneypay from 'components/payments/Inputmoneypay';

const STEPS = {
  SELECT_DELIVERY: 1,
  ADD_AMOUNT: 2
};

export default function PayDelivery({ payment, money, actions, order, ui, provider, delivery, settings, ...props }) {
  const { amount, setAmount } = money;
  const { addPayment, handleCompletePayment } = actions;
  const { details: orderDetails } = order;
  const { buttons } = ui;
  const { setData: setProviderData } = provider;
  const { details: deliveryDetails } = delivery;
  const { paymentSettings } = settings;
  const { selectedMethod } = payment;

  const [step, setStep] = useState(STEPS.SELECT_DELIVERY);
  const [deliveryProvider, setDeliveryProvider] = useState(null);

  const hasAddedPaymentRef = useRef(false);

  useEffect(() => {
    if (selectedMethod && selectedMethod.paymentChannelID === 4) {
      setStep(STEPS.SELECT_DELIVERY);
      setDeliveryProvider(null);
      hasAddedPaymentRef.current = false;
      setAmount('0');
    }
  }, [selectedMethod?.paymentChannelID]);

  useEffect(() => {
    if (selectedMethod?.paymentChannelID === 4 && provider.data === null) {
      setStep(STEPS.SELECT_DELIVERY);
      setDeliveryProvider(null);
      hasAddedPaymentRef.current = false;
    }
  }, [provider.data, selectedMethod?.paymentChannelID]);

  const deliveryList = useMemo(() => {
    if (paymentSettings && Array.isArray(paymentSettings.delivery)) {
      return paymentSettings.delivery;
    }
    return [];
  }, [paymentSettings]);

  const calculateRemainingAmount = useCallback(() => {
    const paymentNetAmount = parseFloat(orderDetails?.paymentNet || 0);
    const paymentTotalAmount = parseFloat(orderDetails?.paymentTotal || 0);
    return Math.max(0, paymentNetAmount - paymentTotalAmount).toFixed(2);
  }, [orderDetails]);

  const addServiceProviderPayment = useCallback(() => {
    if (hasAddedPaymentRef.current) return;

    hasAddedPaymentRef.current = true;

    const remainingAmount = calculateRemainingAmount();

    setAmount(remainingAmount);

    setTimeout(() => {
      addPayment();
    }, 100);
  }, [calculateRemainingAmount, setAmount, addPayment]);

  const handleCheckPaymentChannel = useCallback(() => {
    if (!deliveryProvider) return;

    setProviderData(deliveryProvider);
    hasAddedPaymentRef.current = false;
    setStep(STEPS.ADD_AMOUNT);
    if (deliveryDetails?.paymentChannel === 2) {
      const remainingAmount = calculateRemainingAmount();
      setAmount(remainingAmount);
    }
  }, [deliveryProvider, setProviderData, deliveryDetails, calculateRemainingAmount, setAmount]);

  useEffect(() => {
    if (step === STEPS.ADD_AMOUNT && deliveryDetails?.paymentChannel === 2 && !hasAddedPaymentRef.current) {
      addServiceProviderPayment();
    }
  }, [step, deliveryDetails?.paymentChannel, addServiceProviderPayment]);

  const isPaymentSuccess = parseFloat(orderDetails.paymentTotal) >= parseFloat(orderDetails.paymentNet);

  const isZeroAmount = useMemo(() => {
    if (!amount || amount === '' || amount === '0' || amount === '0.00') {
      return true;
    }
    const numAmount = parseFloat(amount);
    return numAmount === 0 || isNaN(numAmount);
  }, [amount]);

  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'Enter' && step === STEPS.ADD_AMOUNT) {
        if (isZeroAmount || isPaymentSuccess) {
          e.preventDefault();
        } else {
          e.preventDefault();
          addPayment();
        }
      }
    },
    [step, isZeroAmount, isPaymentSuccess, addPayment]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <div className="d-flex flex-column h-100">
      {step === STEPS.ADD_AMOUNT ? (
        <>
          <div className="d-flex align-items-center text-[#061126] mb-1">
            <div className="me-auto">
              <span className="fs-18 fw-500">Order NO.</span>
              <span className="fs-14 fw-500 ms-2">{orderDetails?.orderNo || ''}</span>
            </div>
            <div className="fs-18 fw-bold text-[#2DC76D]">
              {deliveryDetails?.paymentChannel === 2 ? 'ชำระผ่านผู้ให้บริการ' : 'ชำระเงินปกติ'}
            </div>
          </div>

          <div className="fs-14 fw-500 mb-3">กรุณาระบุยอดเงินรับชำระ</div>

          <div className="py-2">
            <Formmoneypay moneypay={amount} setMoneypay={setAmount} />
          </div>

          <Calculate setMoneypay={setAmount} moneypay={amount} PaymentDetail={orderDetails} />

          <div className="d-flex align-items-center pt-2">
            <button
              className="btn btn-st-q1 me-auto px-4"
              onClick={addPayment}
              disabled={isPaymentSuccess || isZeroAmount}
            >
              Enter
            </button>
            <button className="btn btn-st-q1" onClick={handleCompletePayment} disabled={buttons.paymentDisabled}>
              ชำระเงิน
            </button>
          </div>
        </>
      ) : (
        <div className="d-flex h-100 flex-column">
          <div
            className="bx-paylist p-3 overflow-auto mb-auto"
            style={{ background: '#FFF', height: 'calc(100vh - 450px)' }}
          >
            <div className="row">
              {deliveryList && deliveryList.length > 0 ? (
                deliveryList.map((item, index) => (
                  <div className="col-4" key={item.id || index}>
                    <div
                      className="d-flex align-items-center justify-content-center flex-column mb-3"
                      style={{ cursor: 'pointer' }}
                      onClick={() => setDeliveryProvider(item)}
                    >
                      <img
                        src={item.logo}
                        style={{
                          width: '100px',
                          height: '100px',
                          objectFit: 'cover',
                          borderRadius: '8px',
                          ...(deliveryProvider &&
                            item.id === deliveryProvider.id && {
                              border: '5px solid #2DC76D',
                              boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.25)'
                            })
                        }}
                        alt={item.name || 'delivery logo'}
                      />
                      <div className="text-[#061126] fs-16 fw-500 mt-3 ms-3">{item.name}</div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center">No delivery options available</div>
              )}
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end pt-2">
            <button
              className="btn btn-st-q1 px-4"
              onClick={handleCheckPaymentChannel}
              disabled={!(deliveryProvider && calculateRemainingAmount() > 0)}
            >
              ยืนยัน
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
